/* SkalkA storefront behaviour. No framework, no build step. */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = (window.SkalkA && window.SkalkA.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  };

  /* Line item properties that carry no information fragment the cart: Shopify
     treats "same variant, no properties" and "same variant, Engraving: None" as
     two different lines, so the drawer shows the identical product twice and the
     bulk bands stop reading as one order. Anything empty, "None" or "No" is
     dropped before the form is sent — it was never worth printing on the packing
     slip either. */
  function cleanProps(form) {
    var fd = new FormData(form);
    var drop = [];
    fd.forEach(function (v, k) {
      if (k.indexOf('properties[') !== 0) return;
      if (typeof v !== 'string') return;              /* keep uploaded files */
      var t = v.trim().toLowerCase();
      if (t === '' || t === 'none' || t === 'no') drop.push(k);
    });
    drop.forEach(function (k) { fd.delete(k); });
    return fd;
  }

  /* ---------- colour siblings ----------
     Listings split by finish link to each other through swatches. When the buyer
     changes capacity here, each sibling link is re-pointed at the sibling's
     variant with the same capacity, so switching colour keeps the choice. */
  function syncSiblings() {
    var box = document.querySelector('[data-colour-siblings]');
    if (!box) return;
    var label = document.querySelector('[data-option-label="1"]');
    var cur = label ? label.textContent.trim() : '';
    box.querySelectorAll('[data-sibling-url]').forEach(function (a) {
      var map = {};
      (a.dataset.siblingVariants || '').split('|').forEach(function (pair) {
        var i = pair.lastIndexOf('=');
        if (i > 0) map[pair.slice(0, i)] = pair.slice(i + 1);
      });
      var id = map[cur];
      if (id) a.href = a.dataset.siblingUrl + '?variant=' + id;
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-opt]')) setTimeout(syncSiblings, 0);
  });

  /* ---------- mobile nav ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = toggle.closest('.nav');
      nav.dataset.open = nav.dataset.open === 'true' ? 'false' : 'true';
      toggle.setAttribute('aria-expanded', nav.dataset.open);
      return;
    }
    var openNav = document.querySelector('.nav[data-open="true"]');
    if (openNav && !e.target.closest('.nav')) openNav.dataset.open = 'false';
  });

  /* ---------- cart drawer ----------
     One source of truth: after any change we re-read /cart.js and redraw. The
     drawer is a quick view, /cart stays the full page. */
  var drawer = null;

  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* /cart.js hands a file property back as its CDN URL, so an uploaded logo is
     shown as a link the customer can click to confirm they sent the right file. */
  function lineOptions(item) {
    var bits = [];
    if (item.variant_title) bits.push(esc(item.variant_title));
    Object.keys(item.properties || {}).forEach(function (k) {
      var v = item.properties[k];
      if (!v || (k === 'Engraving' && v === 'None')) return;
      if (/^https?:\/\//.test(v)) {
        var name = decodeURIComponent(String(v).split('?')[0].split('/').pop());
        bits.push(esc(k) + ': <a href="' + esc(v) + '" target="_blank" rel="noopener">' + esc(name) + '</a>');
      } else {
        bits.push(esc(k) + ': ' + esc(v));
      }
    });
    return bits.join(' · ');
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    var body = drawer.querySelector('[data-drawer-lines]');
    var foot = drawer.querySelector('[data-drawer-foot]');
    var total = drawer.querySelector('[data-drawer-total]');
    setCartCount(cart.item_count);

    if (!cart.items.length) {
      body.innerHTML = '<p class="drawer__empty">' + esc(drawer.dataset.empty || 'Your cart is empty.') + '</p>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    if (total) total.textContent = money(cart.total_price);

    /* An order-level discount does not show up in final_line_price, so without
       these two rows the lines and the subtotal simply disagree. */
    var goodsRow = drawer.querySelector('[data-drawer-goods]');
    var saveRow = drawer.querySelector('[data-drawer-save]');
    var apps = cart.cart_level_discount_applications || [];
    if (cart.total_discount > 0) {
      if (goodsRow) {
        goodsRow.querySelector('[data-drawer-goods-value]').textContent = money(goodsValue(cart));
        goodsRow.hidden = false;
      }
      if (saveRow) {
        saveRow.querySelector('[data-drawer-save-label]').textContent =
          apps.length ? apps[0].title : 'Discount';
        saveRow.querySelector('[data-drawer-save-value]').textContent = '−' + money(cart.total_discount);
        saveRow.hidden = false;
      }
    } else {
      if (goodsRow) goodsRow.hidden = true;
      if (saveRow) saveRow.hidden = true;
    }

    applyMinimum(goodsValue(cart));

    body.innerHTML = cart.items.map(function (i) {
      var img = i.image ? '<img class="dline__img" src="' + esc(i.image) + '" alt="" loading="lazy">'
                        : '<span class="dline__img"></span>';
      return '<div class="dline" data-key="' + esc(i.key) + '">' + img +
        '<div><a class="dline__name" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' +
        '<span class="dline__opt">' + lineOptions(i) + '</span>' +
        '<div class="dline__ctl">' +
          '<span class="dline__qty">' +
            '<button type="button" data-line-step="-1" aria-label="Decrease">−</button>' +
            '<span>' + i.quantity + '</span>' +
            '<button type="button" data-line-step="1" aria-label="Increase">+</button>' +
          '</span>' +
          '<button type="button" class="dline__rm" data-line-remove aria-label="Remove">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>' +
          '</button>' +
        '</div></div>' +
        '<span class="dline__price">' + money(i.final_line_price) + '</span>' +
      '</div>';
    }).join('');
  }

  /* The minimum is measured on goods before any discount, so a future sale
     cannot push a qualifying cart back under the threshold. */
  function goodsValue(cart) {
    return cart.original_total_price != null ? cart.original_total_price : cart.total_price;
  }

  /* ---------- minimum order ----------
     The subtotal is goods only — /cart.js total_price carries no shipping or
     tax — so comparing it against the threshold is the whole rule. The button
     is an <a>, which cannot be disabled, so it gets aria-disabled and the click
     is swallowed; the gate text says how much is still missing rather than just
     refusing, because a buyer who is told the gap will usually close it. */
  function applyMinimum(subtotal) {
    if (!drawer) return;
    var gate = drawer.querySelector('[data-min-gate]');
    var button = drawer.querySelector('[data-checkout]');
    var min = gate ? parseInt(gate.dataset.min, 10) : 0;
    if (!gate || !min) return;

    var short = min - subtotal;
    var fill = gate.querySelector('[data-gate-fill]');
    var text = gate.querySelector('[data-gate-text]');

    if (short > 0) {
      gate.hidden = false;
      if (fill) fill.style.width = Math.max(2, Math.round(subtotal / min * 100)) + '%';
      if (text) {
        text.textContent = gate.dataset.tmplShort.replace('[[amount]]', money(short)) +
                           ' · ' + gate.dataset.tmplMin;
      }
      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('tabindex', '-1');
      }
    } else {
      gate.hidden = true;
      if (button) {
        button.removeAttribute('aria-disabled');
        button.removeAttribute('tabindex');
      }
    }
  }

  function refreshCart(open) {
    return fetch(window.SkalkA.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        if (open) openDrawer();
        return cart;
      });
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    /* let the browser paint the hidden state once so the slide actually animates */
    requestAnimationFrame(function () { drawer.setAttribute('data-open', 'true'); });
    document.body.style.overflow = 'hidden';
    var close = drawer.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, 220);
  }

  function initDrawer() {
    drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }

      var ck = e.target.closest('[data-checkout]');
      if (ck && ck.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        var gate = drawer.querySelector('[data-min-gate]');
        if (gate) {
          gate.setAttribute('data-nudge', 'true');
          setTimeout(function () { gate.removeAttribute('data-nudge'); }, 500);
        }
        return;
      }

      var openBtn = e.target.closest('[data-cart-open]');
      if (openBtn) { e.preventDefault(); refreshCart(true); return; }

      var step = e.target.closest('[data-line-step]');
      var rm = e.target.closest('[data-line-remove]');
      if (!step && !rm) return;
      var row = (step || rm).closest('.dline');
      if (!row) return;
      var qtyEl = row.querySelector('.dline__qty span');
      var next = rm ? 0 : Math.max(0, parseInt(qtyEl.textContent, 10) + parseInt(step.dataset.lineStep, 10));
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: row.dataset.key, quantity: next })
      }).then(function () { refreshCart(false); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') closeDrawer();
    });
  }

  /* ---------- gallery ---------- */
  /* Every slide is already in the DOM; switching only toggles which one shows and
     re-shapes the frame to that photo's ratio. No network round trip per click. */
  function initGallery(root) {
    var frame = root.querySelector('[data-gal-frame]');
    var slides = root.querySelectorAll('[data-gal-slide]');
    var thumbs = root.querySelectorAll('[data-gal-thumb]');
    if (!frame || !slides.length) return;

    function shape(img) {
      var r = img.dataset.ratio;
      if (r && r.indexOf('/') > 0 && parseInt(r.split('/')[1], 10) > 0) {
        frame.style.aspectRatio = r;
      }
    }
    shape(slides[0]);

    function show(i) {
      slides.forEach(function (s, n) {
        s.hidden = n !== i;
        if (n === i) shape(s);
      });
      thumbs.forEach(function (t, n) {
        t.setAttribute('aria-current', String(n === i));
      });
    }

    /* the engraving pickers need to bring their own chart into view */
    window.SkalkA.gallery = { show: show, count: slides.length };

    thumbs.forEach(function (btn, i) {
      /* warm the full-size image on hover so the click itself is instant */
      var warm = function () {
        var s = slides[i];
        if (s && !s.dataset.warm) { s.dataset.warm = '1'; s.loading = 'eager'; }
      };
      btn.addEventListener('mouseenter', warm);
      btn.addEventListener('focus', warm);
      btn.addEventListener('click', function () { show(i); });
    });

    /* arrow keys walk the gallery once a thumbnail has focus */
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var cur = 0;
      thumbs.forEach(function (t, n) { if (t.getAttribute('aria-current') === 'true') cur = n; });
      var next = e.key === 'ArrowRight' ? (cur + 1) % thumbs.length
                                        : (cur - 1 + thumbs.length) % thumbs.length;
      show(next);
      thumbs[next].focus();
      e.preventDefault();
    });
  }

  /* ---------- product form: stains + engraving + qty + add to cart ---------- */
  function initProduct(form) {
    var variantInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var stainLabel = document.querySelector('[data-stain-label]');
    var addBtn = form.querySelector('[data-add]');
    var addLabel = addBtn ? addBtn.querySelector('[data-add-label]') : null;
    var defaultLabel = addLabel ? addLabel.textContent : '';

    /* ---- option picker: any number of axes (Colour × Capacity, Engraving, …) ---- */
    var dataEl = form.querySelector('[data-variant-data]');
    var variants = [];
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    }

    var qtyInput = form.querySelector('[data-qty]');
    var eachEl = document.querySelector('[data-price-each]');
    var priceOf = 0;

    /* ---- bulk tiers ----
       The Pack option is not a fixed bundle, it is the price band. Quantity stays
       a free number stepping by one, and the band is picked from it: 21 pieces
       sits in the 20+ band, and typing 20 while "1 piece" is highlighted moves to
       the 20+ band by itself. Because the band is a real variant, the checkout
       charges band price x quantity, which is exactly what the page shows. */
    var packGroup = form.querySelector('.optgroup[data-option-name="Pack"]');
    var packIdx = packGroup ? parseInt(packGroup.dataset.optionIndex, 10) - 1 : -1;
    var tiers = [];
    if (packIdx >= 0) {
      var seen = {};
      variants.forEach(function (v) {
        var val = v.opts[packIdx];
        var m = /^(\d+)/.exec(val || '');
        if (!m || seen[val]) return;
        seen[val] = 1;
        tiers.push({ min: parseInt(m[1], 10), value: val });
      });
      tiers.sort(function (a, b) { return a.min - b.min; });
    }

    function tierFor(qty) {
      var pick = tiers[0];
      tiers.forEach(function (t) { if (qty >= t.min) pick = t; });
      return pick;
    }

    /* headline price is what this line costs; the per-piece rate sits under it */
    function paintPrice() {
      var qty = Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10));
      if (priceEl) priceEl.textContent = money(priceOf * qty);
      if (!eachEl) return;
      if (qty > 1) {
        eachEl.hidden = false;
        eachEl.textContent = money(priceOf) + ' each · ' + qty + ' pieces';
      } else {
        eachEl.hidden = true;
      }
    }

    /* label the band buttons with the range and the rate they unlock */
    function labelTiers() {
      if (!packGroup) return;
      packGroup.querySelectorAll('[data-opt]').forEach(function (btn) {
        var t = tiers.filter(function (x) { return x.value === btn.dataset.value; })[0];
        if (!t) return;
        var i = tiers.indexOf(t);
        var range = (i === tiers.length - 1) ? t.min + '+'
                  : t.min + '–' + (tiers[i + 1].min - 1);
        var probe = chosen();
        probe[packIdx] = t.value;
        var v = findVariant(probe);
        btn.innerHTML = '<span class="optpill__range">' + range + '</span>' +
                        (v ? '<span class="optpill__each">' + money(v.price) + ' each</span>' : '');
      });
      var head = packGroup.querySelector('[data-option-label]');
      if (head) head.textContent = money(priceOf) + ' each';
    }

    /* quantity is the source of truth: move the band to match it */
    function syncTierToQty() {
      if (packIdx < 0 || !qtyInput) return false;
      var qty = Math.max(1, parseInt(qtyInput.value || '1', 10));
      var want = tierFor(qty);
      var cur = packGroup.querySelector('[aria-checked="true"]');
      if (cur && cur.dataset.value === want.value) return false;
      packGroup.querySelectorAll('[data-opt]').forEach(function (b) {
        b.setAttribute('aria-checked', String(b.dataset.value === want.value));
      });
      return true;
    }

    /* ---- which design pickers apply to the chosen engraving ---- */
    var dStones = form.querySelector('[data-design-stones]');
    var dLid = form.querySelector('[data-design-lid]');
    var dNote = form.querySelector('[data-design-note]');

    function showDesign(box, on) {
      if (!box) return;
      box.hidden = !on;
      box.querySelectorAll('input').forEach(function (i) { i.disabled = !on; });
    }

    /* jump the gallery to the chart a picker refers to, 1-based in Liquid */
    function openChart(box) {
      var g = window.SkalkA.gallery;
      if (!box || !g) return;
      var i = parseInt(box.dataset.chart || '0', 10) - 1;
      if (i >= 0 && i < g.count) g.show(i);
    }

    function syncDesign(v) {
      if (!dStones && !dLid && !dNote) return;
      var eng = '';
      v.opts.forEach(function (o) { if (/engrav|stone|lid/i.test(o)) eng = o; });
      var low = eng.toLowerCase();
      var none = low.indexOf('no engraving') === 0 || low === '';
      var wantStones = !none && low.indexOf('stone') !== -1;
      var wantLid = !none && low.indexOf('lid') !== -1;
      var changed = (dStones && dStones.hidden === wantStones) ||
                    (dLid && dLid.hidden === wantLid);
      showDesign(dStones, wantStones);
      showDesign(dLid, wantLid);
      showDesign(dNote, !none);
      markCustom();
      /* opening a picker shows what it is asking about — stones win when both apply */
      if (changed) openChart(wantStones ? dStones : (wantLid ? dLid : null));
    }

    /* the last lid tile is "Custom": the note becomes the artwork brief */
    var noteInput = form.querySelector('[data-design-note-input]');
    var noteErr = form.querySelector('[data-note-error]');
    function customPicked() {
      if (!dLid || dLid.hidden) return false;
      var on = dLid.querySelector('[aria-checked="true"]');
      return !!on && on.dataset.value === dLid.dataset.custom;
    }
    function markCustom() {
      if (!noteInput) return;
      var need = customPicked();
      noteInput.placeholder = need ? 'Describe the engraving you want — required'
                                   : 'Name, date, call sign or a note about the artwork';
      if (!need && noteErr) noteErr.hidden = true;
    }

    function chosen() {
      var picked = [];
      form.querySelectorAll('.optgroup').forEach(function (g) {
        var on = g.querySelector('[aria-checked="true"]');
        picked[parseInt(g.dataset.optionIndex, 10) - 1] = on ? on.dataset.value : null;
      });
      return picked;
    }

    function findVariant(picked) {
      return variants.find(function (v) {
        return picked.every(function (val, i) { return val === null || v.opts[i] === val; });
      });
    }

    /* A value is offered only if some variant pairs it with the other current choices. */
    function refresh() {
      var picked = chosen();
      form.querySelectorAll('.optgroup').forEach(function (g) {
        var idx = parseInt(g.dataset.optionIndex, 10) - 1;
        g.querySelectorAll('[data-opt]').forEach(function (btn) {
          var probe = picked.slice();
          probe[idx] = btn.dataset.value;
          var v = findVariant(probe);
          btn.disabled = !v || !v.available;
        });
      });

      var v = findVariant(picked);
      if (!v) return;
      variantInput.value = v.id;

      priceOf = v.price;
      paintPrice();
      labelTiers();
      syncDesign(v);

      form.querySelectorAll('.optgroup').forEach(function (g) {
        if (g === packGroup) return;   /* its heading shows the rate, not the value */
        var idx = parseInt(g.dataset.optionIndex, 10) - 1;
        var label = g.querySelector('[data-option-label]');
        if (label) label.textContent = v.opts[idx];
      });
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? defaultLabel : 'Sold out';
      }
      /* keep the URL shareable, the way Shopify's own themes do */
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u);
      }
    }

    form.querySelectorAll('[data-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var group = btn.closest('.optgroup');
        group.querySelectorAll('[data-opt]').forEach(function (b) {
          b.setAttribute('aria-checked', 'false');
        });
        btn.setAttribute('aria-checked', 'true');
        /* clicking a band is a shortcut: jump the quantity to where it starts */
        if (group === packGroup && qtyInput) {
          var t = tiers.filter(function (x) { return x.value === btn.dataset.value; })[0];
          if (t) qtyInput.value = t.min;
        }
        refresh();
      });
    });
    form.querySelectorAll('[data-design]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var kind = btn.dataset.design;
        form.querySelectorAll('[data-design="' + kind + '"]').forEach(function (b) {
          b.setAttribute('aria-checked', 'false');
        });
        btn.setAttribute('aria-checked', 'true');
        var input = form.querySelector('[data-design-input="' + kind + '"]');
        var label = form.querySelector('[data-design-label="' + kind + '"]');
        if (input) input.value = btn.dataset.value;
        if (label) label.textContent = btn.dataset.value;
        openChart(btn.closest('.design'));
        markCustom();
      });
    });

    if (variants.length) { syncTierToQty(); refresh(); }

    /* engraving mode: none | logo | text */
    var modeInput = form.querySelector('[data-engraving-mode]');
    var dropZone = form.querySelector('[data-engraving-drop]');
    var textZone = form.querySelector('[data-engraving-text]');
    var fileInput = form.querySelector('[data-engraving-file]');
    var textInput = form.querySelector('[data-engraving-input]');

    var placeBox = form.querySelector('[data-logo-placement]');
    var placeInput = form.querySelector('[data-place-input]');
    var placeLabel = form.querySelector('[data-place-label]');

    function setMode(mode) {
      if (modeInput) modeInput.value = mode === 'none' ? 'None' : (mode === 'logo' ? 'Your logo' : 'Custom text');
      if (dropZone) dropZone.hidden = mode !== 'logo';
      if (textZone) textZone.hidden = mode !== 'text';
      /* where to put the mark only matters once there is a mark to put */
      if (placeBox) placeBox.hidden = mode === 'none';
      if (placeInput) placeInput.disabled = mode === 'none';
      /* a disabled input is not submitted — that keeps unused properties out of the line item */
      if (fileInput) fileInput.disabled = mode !== 'logo';
      if (textInput) textInput.disabled = mode !== 'text';
      form.querySelectorAll('[data-engraving-btn]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.engravingBtn === mode));
      });
    }
    form.querySelectorAll('[data-engraving-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () { setMode(btn.dataset.engravingBtn); });
    });
    setMode('none');

    if (placeBox) {
      placeBox.querySelectorAll('[data-place]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          placeBox.querySelectorAll('[data-place]').forEach(function (b) {
            b.setAttribute('aria-checked', 'false');
          });
          btn.setAttribute('aria-checked', 'true');
          if (placeInput) placeInput.value = btn.dataset.place;
          if (placeLabel) placeLabel.textContent = btn.dataset.place;
        });
      });
    }

    /* our own filename readout — the native input's is in the browser's language */
    var nameEl = form.querySelector('[data-file-name]');
    var nameIdle = nameEl ? nameEl.textContent : '';
    function showFile() {
      if (!nameEl || !fileInput) return;
      var f = fileInput.files && fileInput.files[0];
      nameEl.textContent = f ? f.name : nameIdle;
      nameEl.setAttribute('data-has-file', String(!!f));
    }
    if (fileInput) fileInput.addEventListener('change', showFile);

    /* the copy promises "drop your logo here", so make dropping actually work */
    if (dropZone && fileInput) {
      ['dragenter', 'dragover'].forEach(function (t) {
        dropZone.addEventListener(t, function (e) {
          e.preventDefault();
          dropZone.setAttribute('data-over', 'true');
        });
      });
      ['dragleave', 'dragend', 'drop'].forEach(function (t) {
        dropZone.addEventListener(t, function () { dropZone.setAttribute('data-over', 'false'); });
      });
      dropZone.addEventListener('drop', function (e) {
        e.preventDefault();
        if (!e.dataTransfer || !e.dataTransfer.files.length) return;
        try {
          var dt = new DataTransfer();
          dt.items.add(e.dataTransfer.files[0]);
          fileInput.files = dt.files;
          showFile();
        } catch (err) { /* older browsers: the Choose a file button still works */ }
      });
    }

    /* quantity always moves by one; the band follows it */
    function onQty() {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10));
      if (syncTierToQty()) refresh(); else paintPrice();
    }
    form.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        qtyInput.value = parseInt(qtyInput.value || '1', 10) + parseInt(btn.dataset.qtyStep, 10);
        onQty();
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('input', onQty);
      qtyInput.addEventListener('change', onQty);
    }

    /* wording is mandatory on the plate frames — refuse the add rather than
       let an order arrive with nothing to cut */
    var reqText = form.querySelector('[data-required-text]');
    var reqErr = form.querySelector('[data-text-error]');
    var reqCount = form.querySelector('[data-text-count]');
    if (reqText) {
      var tick = function () {
        if (reqCount) reqCount.textContent = reqText.value.length + '/' + (reqText.maxLength || 16);
        if (reqText.value.trim()) {
          reqText.setAttribute('aria-invalid', 'false');
          if (reqErr) reqErr.hidden = true;
        }
      };
      reqText.addEventListener('input', tick);
      tick();
    }

    /* add to cart — a file property forces multipart, so always send FormData */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (customPicked() && noteInput && !noteInput.value.trim()) {
        if (noteErr) noteErr.hidden = false;
        noteInput.focus();
        noteInput.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      if (reqText && !reqText.value.trim()) {
        reqText.setAttribute('aria-invalid', 'true');
        if (reqErr) reqErr.hidden = false;
        reqText.focus();
        reqText.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      if (textInput && !textInput.disabled && !textInput.value.trim()) {
        textInput.focus();
        return;
      }
      addBtn.disabled = true;
      fetch(window.SkalkA.routes.cart_add, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: cleanProps(form)
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          addBtn.disabled = false;
          if (!res.ok) {
            if (addLabel) addLabel.textContent = res.body.description || 'Could not add';
            setTimeout(function () { if (addLabel) addLabel.textContent = defaultLabel; }, 3000);
            return;
          }
          if (addLabel) addLabel.textContent = 'Added ✓ — add more';
          setTimeout(function () { if (addLabel) addLabel.textContent = defaultLabel; }, 2500);
          return refreshCart(true);   /* slide the drawer out with the new line in it */
        })
        .catch(function () {
          addBtn.disabled = false;
          if (addLabel) addLabel.textContent = 'Network error — try again';
          setTimeout(function () { if (addLabel) addLabel.textContent = defaultLabel; }, 3000);
        });
    });
  }

  /* ---------- catalog: show more ---------- */
  function initShowMore(root) {
    var btn = root.querySelector('[data-show-more]');
    if (!btn) return;
    var step = parseInt(btn.dataset.step || '12', 10);
    btn.addEventListener('click', function () {
      var hidden = root.querySelectorAll('[data-card][hidden]');
      Array.prototype.slice.call(hidden, 0, step).forEach(function (el) { el.hidden = false; });
      var left = root.querySelectorAll('[data-card][hidden]').length;
      if (left === 0) btn.hidden = true;
      else btn.textContent = 'Show more (' + left + ' left)';
    });
  }

  /* ---------- sticky buy bar ---------- */
  function initStickyBuy() {
    var bar = document.querySelector('[data-sticky-buy]');
    var form = document.querySelector('[data-product-form]');
    if (!bar || !form) return;
    var realBtn = form.querySelector('[data-add]');
    var price = document.querySelector('[data-price]');
    var mirror = bar.querySelector('[data-sticky-price]');

    bar.querySelector('[data-sticky-add]').addEventListener('click', function () {
      form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
    });

    /* mirror the live price, which the option picker rewrites */
    if (price && mirror && window.MutationObserver) {
      new MutationObserver(function () {
        mirror.textContent = price.textContent.trim();
      }).observe(price, { childList: true, characterData: true, subtree: true });
    }

    /* show it once the real button is off screen */
    if (window.IntersectionObserver && realBtn) {
      new IntersectionObserver(function (entries) {
        bar.setAttribute('data-show', String(!entries[0].isIntersecting));
        bar.setAttribute('aria-hidden', String(entries[0].isIntersecting));
      }, { rootMargin: '0px 0px -20px 0px' }).observe(realBtn);
    }
  }


  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-product-form]').forEach(initProduct);
    document.querySelectorAll('[data-catalog]').forEach(initShowMore);
    initStickyBuy();
    initDrawer();
  });
})();
